import { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import axios from 'axios';
import { getToken } from '../utils';
import { LoadingMode } from '../Components/LoadingMode';

function PrivacyPolicies() {
  const [isLoading, setIsLoading] = useState(false);
  const [polycies, setpolycies] = useState({});
  const { token: userToken } = getToken();

  useEffect(() => {
    const data = { note_type_id: 2 };

    const privacyPolicie = async () => {
      setIsLoading(true);
      const url = `${process.env.REACT_APP_BASE_URL}/dashboard/note`;
      try {
        const response = await axios.post(url, data, {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        setpolycies(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    privacyPolicie();
  }, [userToken]);

  const sanitizedHtml = DOMPurify.sanitize(polycies?.note);
  return isLoading ? (
    <LoadingMode />
  ) : (
    <section className=''>
      <div>
        <div className='font-semibold text-2xl text-center mb-12 flex flex-row gap-4 items-center justify-center bg-f-bk py-12 px-6 text-p-bk'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='28'
            height='28'
            viewBox='0 0 24 24'
            className='text-p-bk/70'
          >
            <path
              fill='currentColor'
              d='M21 6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.52-.23-1.11-.23-1.62 0l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12c2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12a4.994 4.994 0 0 1-6.29-.64a5.003 5.003 0 0 1 0-7.07a5.003 5.003 0 0 1 7.07 0a5.006 5.006 0 0 1 .64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V6.3z'
            />
            <circle cx='12' cy='12' r='3' fill='currentColor' />
          </svg>
          <h2 className=''>Privacy Policy</h2>
        </div>
        <div
          className='px-6 md:px-14 text-sm md:text-lg overflow-hidden'
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        >
          {/* <p>{polycies?.note}</p> */}
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicies;
